import React, { useEffect, useState, useRef } from 'react';
import page1Slogan from '@/assets/images/page1Slogan.png';
import item1 from '@/assets/images/item1.png';

import styles from './index.less';

const Page = (props) => {

  const refItem1 = useRef();
  const [itemState,setItemState] = useState(0);

  useEffect(()=>{
    if(refItem1.current){
      runItem1();
    }
  },[]);

  const runItem1=()=>{
    if(itemState)return;
    setItemState(1);
    let tl = gsap.timeline()
    tl.to(refItem1.current, {
      duration:10,
      rotation:360,
      repeat:-1,
      ease:"none"
    })

    let t2 = gsap.timeline()
    t2.to(refItem1.current, {
      duration:2,
      y:"random(-10, 30, 1)",
      scale:"random(0.9,1.2,0.1)",
      ease:"none"
      
    }).to(refItem1.current,{
      duration:2,
      y:"0",
      scale:"1",
      ease:"none",
      onComplete:()=>{
        t2.restart();
      },
    });
  }
 
  return (
    <section className={styles.wrap} data-active={props.show}>
      <img src={page1Slogan} className={`${styles.slogan} ${props.show?styles.anSlogan:''}`}/>
      <img ref={refItem1} src={item1} className={styles.item1} />
    </section>
  )
}

export default Page;